import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import UniversalModal from "../../universalModal";
import NotificationWindow from "../../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";

import { headerName, getRangeMSModal, setDataRangeMS, setFieldsStateByMode } from "./constantsRangeMSModal";

import {
  createRangeMS,
  updateRangeMS,
} from "../../../../../redux/directoryMaintenance/rangeMS/actionsRangeMS";

import styles from "./rangeMSModal.module.css";

function RangeMSModal({ setShow, show, type, setSave }) {
  const dispatch = useDispatch();

  const [showNotification, setShowNotification] = useState(false);
  // const [isError, setIsError] = useState(true);
  const [isSave, setIsSave] = useState(false);
  const [messageText, setMessageText] = useState("");

  const [fields, setFields] = useState([]);
  const [initialFieldsData, setInitialFieldsData] = useState({});

  const gimsSections = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer.gimsSections;
  });

  const rangeMS = useSelector((state) => {
    const { rangeMSReducer } = state;
    return rangeMSReducer.rangeMS;
  });

  const allRangeMS = useSelector((state) => state.dictionaryReducer.allRangeMS);

  async function setParamsForOptions() {
    await setDataRangeMS(gimsSections, "sctName");

    await setFieldsStateByMode(type);

    setFields(Object.values(getRangeMSModal()));
  }
  const handleSaveClick = async (data) => {
    if (type === "add") {
      const validRangesArray = allRangeMS.filter((item) => item.sctId === data.sctName);

      if (validRangesArray.length && validRangesArray.some((item) => !item.dateEnd)) {
        setIsSave(false);
        setShowNotification(true);
        setMessageText(
          "Участок с таким названием уже существует. Задайте дату окончания его действия, чтобы создать новый.",
        );
        return false;
      }
      const latestRange =
        validRangesArray.length > 0
          ? validRangesArray.sort(
              (a, b) =>
                new Date(b.dateEnd.includes(".") ? b.dateEnd.split(".").reverse().join("-") : b.dateEnd) -
                new Date(a.dateEnd.includes(".") ? a.dateEnd.split(".").reverse().join("-") : a.dateEnd),
            )[0]
          : false;
      if (latestRange) {
        if (
          new Date(data.dateStart) <
          new Date(
            latestRange.dateEnd.includes(".")
              ? latestRange.dateEnd.split(".").reverse().join("-")
              : latestRange.dateEnd,
          )
        ) {
          setIsSave(false);
          setShowNotification(true);
          setMessageText(
            "Диапазон номеров по участку не может начинаться раньше окончания действия предыдущего диапазона.",
          );
          return false;
        }
      }
      dispatch(createRangeMS({ ...data, sctId: data.sctName }));
      setShowNotification(true);
      setIsSave(true);
      setMessageText("Диапазон успешно добавлен.");
      return false;
    }
    if (type === "edit") {
      dispatch(updateRangeMS(rangeMS.id, { ...data }));
      setShowNotification(true);
      setIsSave(true);
      setMessageText("Изменения успешно сохранены.");
      return false;
    }
    // return true;
    // setSave();
    // setShow(false);
  };

  useEffect(() => {
    setParamsForOptions().then();
  }, []);

  useEffect(() => {
    const initialData = {};
    fields.forEach((field) => {
      initialData[field.key] = field.type === "text" ? "" : null;
    });
    setInitialFieldsData(initialData);
  }, [fields]);

  return (
    <>
      <UniversalModal
        show={show}
        onHide={() => setShow(false)}
        onSave={(data) => handleSaveClick(data)}
        fields={fields}
        initialFieldsData={initialFieldsData}
        initialData={rangeMS}
        headerName={headerName[type]}
        type={type}
        size="lg"
        stylesFromParent={styles}
        defaultValueSelector={{ value: rangeMS.sctId, label: rangeMS.sctName }}
      />
      <NotificationWindow
        isError={true}
        show={showNotification}
        onClose={() => {
          if (!isSave) {
            setShowNotification(false);
          } else {
            setSave();
            setShow(false);
          }
        }}
        setShow={setShowNotification}
        headerText={"Уведомление"}
        messageText={messageText}
      />
    </>
  );
}

export default RangeMSModal;
